import FloatingInput from './FloatingInput'

export default FloatingInput
